<template>
    <div class="select-dente-interno" 
        :style="{ '--size': size + 'px' }"
        :data-tipo="detalhesDente.tipo"
        :data-lado="detalhesDente.lado" 
        :data-posicao="detalhesDente.posicao">
        <template v-if="tipoSelect === 'raiz'">
            <incisivoPorcoesRaizSvg v-if="detalhesDente.tipo === 'anterior'" />
            <molarPorcoesRaizSvg v-if="detalhesDente.tipo === 'posterior'" />
        </template>
        <template v-if="tipoSelect === 'dente_completo'">
            <incisivoPorcoesDenteCompletoSvg v-if="detalhesDente.tipo === 'anterior'" />
            <molarPorcoesDenteCompletoSvg v-if="detalhesDente.tipo === 'posterior'" />
        </template>
    </div>
</template>

<script>
import { selectDenteMixin } from '../../mixins/selectDenteMixin';
import incisivoPorcoesRaizSvg from '../../lib/resources/svgs/incisivo_porcoes_raiz.svg';
import incisivoPorcoesDenteCompletoSvg from '../../lib/resources/svgs/incisivo_porcoes_dente_completo.svg';
import molarPorcoesRaizSvg from '../../lib/resources/svgs/molar_porcoes_raiz.svg';
import molarPorcoesDenteCompletoSvg from '../../lib/resources/svgs/molar_porcoes_dente_completo.svg';

export default {
    name: 'selectPorcoesDente',
    components: {
        incisivoPorcoesRaizSvg,
        incisivoPorcoesDenteCompletoSvg,
        molarPorcoesRaizSvg,
        molarPorcoesDenteCompletoSvg,
    },
    mixins: [selectDenteMixin],
    props: {
        /**
         * 'raiz' ou 'dente_completo'
         */
        tipoSelect: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
@import '../../styles/_select_dente_interno.css';
</style>